'use strict';

$('a.megaMenuAnchorLink').click(function (event) {
    //var currentURL = window.location.href;
    var urlPathNoAnchor = this.getAttribute("href").split("#")[0];
    //the current page is the same with the mega menu item's anchor link
    if (window.location.pathname === urlPathNoAnchor)
    {
        event.preventDefault();
        //hide all accordion items first
        $(".acc-title").removeClass("active");
        $(".acc-content").hide();

        var anchorSection = this.dataset.anchorid;
        if (anchorSection !== null && anchorSection !== "") {
            var label = document.getElementById("lbl" + anchorSection);
            if (label !== null) {
                label.classList.add("active");
            }
            var content = document.getElementById("content" + anchorSection);
            if (content !== null) {
                content.style.display = "block";
            }
            //jump to new anchor link accordion item
            var url = location.href;               
            location.href = "#" + anchorSection;                 
            history.replaceState(null, null, url);
        }
    }
});